import { CustomPropertyType, RecordType } from 'Services/MongoRealm/Types';
import { SText, SETVIImage } from '@setvi/shared/components';
import { Box } from '@material-ui/core';
import {
  Table,
  TableData
} from 'componentsV2/product/product-details/content/subpages/product-info/specifications/components/table';
import { Link } from './link';
import { BooleanValue } from './boolean';
import { ArrayStringValue } from './array-string';

interface SpecificationComponentProps {
  recordType: RecordType;
}

export const SpecificationComponent = ({
  recordType
}: SpecificationComponentProps) => {
  // Common styles for all specification components to handle overflow
  const containerStyles = {
    overflowX: 'auto' as const,
    overflowY: 'hidden' as const,
    maxWidth: '100%',
    width: '100%'
  };

  if (recordType.type === CustomPropertyType.Link)
    return (
      <Box style={containerStyles}>
        <Link href={recordType.value as string}>{recordType.value}</Link>
      </Box>
    );

  if (recordType.type === CustomPropertyType.Boolean) {
    if (recordType.value === 'Yes' || recordType.value === 'No')
      return (
        <Box style={containerStyles}>
          <SText
            noLineClamp
            weight="bold"
            title={recordType.value === 'Yes' ? 'Yes' : 'No'}
          />
        </Box>
      );

    return (
      <Box style={containerStyles}>
        <BooleanValue value={recordType.value as boolean} />
      </Box>
    );
  }

  if (recordType.type === CustomPropertyType.String)
    return (
      <Box style={containerStyles}>
        <SText
          noLineClamp
          weight="bold"
          style={{
            wordBreak: 'break-word',
            minWidth: 'fit-content',
            whiteSpace: 'nowrap'
          }}
          title={recordType.value as string}
        />
      </Box>
    );

  if (recordType.type === CustomPropertyType.HTML) {
    return (
      <Box style={containerStyles}>
        <div
          style={{ minWidth: 'fit-content' }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: recordType.value }}
        />
      </Box>
    );
  }

  if (recordType.type === CustomPropertyType.ArrayString)
    return (
      <Box style={containerStyles}>
        <ArrayStringValue values={recordType.value as Array<string>} />
      </Box>
    );

  if (recordType.type === CustomPropertyType.Table)
    return (
      <Box style={containerStyles}>
        <Table
          values={recordType.value as unknown as { [key: string]: TableData }[]}
        />
      </Box>
    );

  if (recordType.type === CustomPropertyType.LabeledImageArray) {
    const values = recordType.value as unknown as {
      label: string;
      value: string;
    }[];

    return (
      <Box style={containerStyles}>
        <Box style={{ minWidth: 'fit-content' }}>
          {values.map(item => (
            <Box key={item.label} display="flex" alignItems="center" mb={1}>
              <SETVIImage
                style={{ height: '35px', marginRight: '10px' }}
                src={item.value.split(';')[2]}
                alt={item.label}
              />
              <SText title={item.label} />
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box style={containerStyles}>
      <SText
        noLineClamp
        weight="bold"
        style={{ minWidth: 'fit-content', whiteSpace: 'nowrap' }}
        title={JSON.stringify(recordType.value)}
      />
    </Box>
  );
};
